import React from "react";
import styled from "styled-components";
import { NetworkStatus } from "apollo-client";
import { isEmpty } from "lodash";
import {
  Scroller,
  ScrollerContent,
} from "@sonder/ui/source/styled/fragments/Scroller";
import { Table } from "@sonder/ui/source/styled/fragments/Table";
import { sizes } from "@sonder/ui/source/styled/theme";
import { useStore as useAuthStore } from "auth/store";
import { HeaderRow } from "checkouts/components/HeaderRow";
import { Row } from "checkouts/components/Row";
import { useStore } from "checkouts/store";
import { THIRTY_SECONDS } from "core/constants";
import { usePageVisibilityPolling } from "core/hooks/usePageVisibilityPolling";
import { useRefetchableGetInquiryCheckoutsQuery } from "core/queries/GetInquiryCheckouts";
import { useStore as useScheduleStore } from "schedule/store";
import { EmptyRow, TaskTitle } from "tasks/components/TaskList";
import { useStore as useTasksStore } from "tasks/store";

const StyledScroller = styled(Scroller)`
  border-radius: 0 0 0.3rem 0.3rem;
`;

export const CheckoutsListOuterContainer = styled.div`
  box-sizing: border-box;
  max-width: ${sizes.listWidth};
  margin: 0 auto;
  width: 100%;
  padding: 1rem 1rem 1rem 1.5rem;
`;

export const CheckoutsList = () => {
  const {
    state: {
      filters: { checkoutStatuses },
      sort,
    },
  } = useStore();
  const {
    state: { user },
  } = useAuthStore();
  const {
    state: {
      dateRange,
      filters: { sameDayCleansOnly },
    },
  } = useScheduleStore();
  const {
    state: {
      filters: { buildingIds },
    },
  } = useTasksStore();

  const variables = {
    filters: {
      cityIds: user?.cityId ? [user?.cityId] : [],
      buildingIds,
      checkOutTimeFrom: dateRange.startAt.toISOString(),
      checkOutTimeTo: dateRange.endAt.toISOString(),
      checkoutStatuses,
      // Misnomer here, sameDayCleansOnly is because we are re-using UI from scheduler.
      sameDayOnly: sameDayCleansOnly,
    },
    sort,
  };

  const {
    loading,
    data,
    error,
    networkStatus,
    refetch,
    startPolling,
    stopPolling,
  } = useRefetchableGetInquiryCheckoutsQuery({
    pollInterval: THIRTY_SECONDS,
    skip: !user?.cityId,
    variables,
  });
  usePageVisibilityPolling({
    pollInterval: THIRTY_SECONDS,
    refetch,
    variables,
    startPolling,
    stopPolling,
  });
  const bookings = data?.inquiryCheckoutConnections.inquiries || [];
  const total = data?.inquiryCheckoutConnections.total || 0;
  const isPolling = networkStatus === NetworkStatus.poll;
  const isRefetching = networkStatus === NetworkStatus.refetch;
  const isAcuallyLoading = loading && !isPolling && !isRefetching;
  return (
    <CheckoutsListOuterContainer>
      <TaskTitle count={total} isCollapsed={false} title="Checkouts" />
      <StyledScroller>
        <ScrollerContent>
          <Table columns="15rem 12rem 8rem minmax(10rem, 1fr) minmax(10rem, 1fr) minmax(10rem, 1fr) 1fr">
            <HeaderRow />
            {isEmpty(bookings) && (
              <EmptyRow
                errorLabel={error ? "Something went wrong" : undefined}
                label="No bookings"
                loadingLabel={isAcuallyLoading ? "Loading..." : undefined}
              />
            )}
            {bookings.map((booking, index) => (
              <Row
                booking={booking}
                key={booking.id}
                lastRow={index === bookings.length - 1}
                loading={isAcuallyLoading}
              />
            ))}
          </Table>
        </ScrollerContent>
      </StyledScroller>
    </CheckoutsListOuterContainer>
  );
};
